
// import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
// import CustomCarousel from './CustomCarousel';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
// import FAQSection from './FAQSection';
import FAQItem from './FAQItem';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Explorepanindia() {



  const cardData =
  {
    keyword: 'Explorer Pan India Cab Service from Pune',
    heading: 'AB Ghule Cabs: Explorer Pan India Cab Service from Pune',
    headingDescription: 'Looking to explore India with a comfortable and reliable cab service? AB Ghule Cabs offers an exceptional Pan India Explorer Cab Service from Pune, designed to take you on an unforgettable journey across the country. Whether you are planning a long road trip, visiting iconic landmarks, or exploring hidden gems, our well-maintained fleet and professional drivers ensure a safe, smooth, and hassle-free ride to your desired destination anywhere in India.',

    top: 'Top Places to Visit Across India with AB Ghule Cabs',

    topPlaces: [
        {
            title: "Taj Mahal, Agra (Uttar Pradesh)",
            description: "Visit the majestic Taj Mahal, one of the Seven Wonders of the World. This iconic monument, known for its grandeur and love story, is a must-see on any trip to India."
        },
        {
            title: "Jaipur (Rajasthan)",
            description: "Explore the Pink City with its rich history, magnificent forts, palaces, and vibrant bazaars. Must-visit places include Amber Fort, City Palace, Hawa Mahal, and Jantar Mantar."
        },
        {
            title: "Varanasi (Uttar Pradesh)",
            description: "Experience the spiritual heart of India by visiting Varanasi, one of the oldest living cities in the world. Witness the mesmerizing Ganga Aarti at Dashashwamedh Ghat and explore the narrow lanes of this ancient city."
        },
        {
            title: "Goa",
            description: "Known for its stunning beaches, vibrant nightlife, and Portuguese heritage, Goa is the perfect destination for relaxation and adventure. Enjoy the beautiful coastal scenery and diverse culture."
        },
        {
            title: "Kerala Backwaters (Kerala)",
            description: "Experience the tranquility of Kerala’s backwaters by boat. Cruise through lush landscapes, traditional Kerala villages, and scenic lakes for a peaceful and scenic getaway."
        },
        {
            title: "Hampi (Karnataka)",
            description: "Discover the ancient ruins of the Vijayanagara Empire in Hampi, a UNESCO World Heritage site. The temples, palaces, and stone monuments make it a history lover’s paradise."
        },
        {
            title: "Amritsar (Punjab)",
            description: "Pay a visit to the Golden Temple, the holiest place for Sikhs. Amritsar is also home to the Jallianwala Bagh memorial, a site of historical significance."
        },
        {
            title: "Leh-Ladakh (Jammu & Kashmir)",
            description: "For adventure seekers and nature lovers, Leh-Ladakh offers stunning landscapes, monasteries, and high-altitude treks. Explore the rugged mountains, pristine lakes, and unique Buddhist culture."
        },
        {
            title: "Mysore (Karnataka)",
            description: "Visit the Mysore Palace, a beautiful historical site, and the famous Chamundi Hill Temple. Mysore is also known for its silk, sandalwood, and delicious local sweets."
        },
        {
            title: "Sikkim",
            description: "Known for its breathtaking natural beauty and Buddhist monasteries, Sikkim offers a peaceful retreat with its picturesque landscapes, including Tsomgo Lake, Yumthang Valley, and Khangchendzonga National Park."
        }
    ],


    services: [
        {
          "name": "Pune to Ayodhya Cab Service",
          description: "Book your Pune to Ayodhya cab with AB Ghule Cabs. We offer reliable, affordable, and comfortable taxi services to Ayodhya, ensuring a smooth and safe journey with professional drivers."
        },
        {
          "name": "Pune to Taj Mahal Cabs Service",
          description: "Travel comfortably with AB Ghule Cabs on your journey from Pune to the Taj Mahal. Our reliable cab service offers competitive fares and well-maintained vehicles for a safe and enjoyable trip to this iconic monument."
        },
        {
          "name": "Pune to Kolkata Taxi Fare",
          description: "Get the best taxi fare for your journey from Pune to Kolkata with AB Ghule Cabs. We offer transparent pricing with no hidden charges, ensuring a comfortable and affordable trip to Kolkata."
        },
        {
          "name": "Pune to Goa Taxi Fare",
          description: "Travel from Pune to Goa in comfort with AB Ghule Cabs. We offer competitive taxi fares and ensure a safe and relaxing journey with experienced drivers and well-maintained vehicles."
        },
        {
          "name": "Pune to Chennai Cab Service",
          description: "AB Ghule Cabs provides reliable and affordable Pune to Chennai cab services. Our fleet of vehicles ensures comfort and safety, whether it’s a one-way or round-trip journey to Chennai."
        },
        {
          "name": "Pune to Delhi Cab Service",
          description: "Book your Pune to Delhi cab with AB Ghule Cabs for a comfortable and hassle-free journey. We offer reliable taxi services with well-maintained vehicles and experienced drivers for your convenience."
        },
        {
          "name": "Pune to Mysore Ooty Cab Package",
          description: "Explore Mysore and Ooty with AB Ghule Cabs. Our Pune to Mysore Ooty cab package offers comfortable rides and a personalized travel experience to these popular destinations."
        },
        {
          "name": "Pune to Kanyakumari Taxi Package",
          description: "Travel from Pune to Kanyakumari with AB Ghule Cabs. Our taxi package includes comfortable, reliable rides with professional drivers, ensuring a memorable journey to the southernmost point of India."
        },
        {
          "name": "Pune to Kerala Cab Package",
          description: "Book your Pune to Kerala cab package with AB Ghule Cabs. Our package includes a comfortable and affordable taxi ride to Kerala, along with well-maintained vehicles and professional drivers to ensure a smooth trip."
        },
        {
          "name": "Taxi Booking Service in Pune",
          description: "For convenient and reliable taxi booking services in Pune, choose AB Ghule Cabs. Our online booking system allows you to book taxis for local and outstation trips with ease and confidence."
        },
        {
          "name": "Pune to Bhopal Cab Service",
          description: "AB Ghule Cabs offers affordable and reliable Pune to Bhopal cab services. Whether it's a one-way trip or a round trip, our experienced drivers and well-maintained vehicles ensure a smooth and safe journey."
        },
        {
          "name": "Best Travel Agents in Pimpri Chinchwad",
          description: "For the best travel agents in Pimpri Chinchwad, trust AB Ghule Cabs. We offer reliable and affordable taxi services, making your travel experience comfortable and hassle-free."
        },
        {
          "name": "Pune to Nagpur Cab Booking",
          description: "Book your Pune to Nagpur cab with AB Ghule Cabs. Our reliable taxi services ensure a smooth journey with experienced drivers and well-maintained vehicles, offering you a comfortable ride."
        },
        {
          "name": "Pune to Patna Cab Service",
          description: "AB Ghule Cabs offers Pune to Patna cab services for a comfortable and affordable journey. Our fleet of vehicles ensures safety and comfort, with professional drivers ensuring a smooth trip."
        },
        {
          "name": "Pune to Madras Cab Service",
          description: "Travel to Madras (Chennai) with AB Ghule Cabs. Our Pune to Madras cab service offers a reliable, comfortable, and affordable ride, ensuring you reach your destination safely and on time."
        },
        {
          "name": "Pune to 12 Jyotirlinga Darshan Tour Package",
          description: "Book a special tour package with AB Ghule Cabs for the 12 Jyotirlinga Darshan. We provide comfortable taxi services to all the sacred Jyotirlinga temples, ensuring a safe and spiritual journey."
        },
        {
          "name": "Pune to 5 Jyotirlinga Darshan Cabs",
          description: "Book a cab for the 5 Jyotirlinga Darshan tour with AB Ghule Cabs. Our service offers well-maintained vehicles and professional drivers for a smooth and spiritual journey to the 5 Jyotirlingas."
        },
        {
          "name": "Pune to Ashtavinayak Darshan Cab",
          description: "For a comfortable and hassle-free Ashtavinayak Darshan, book your cab with AB Ghule Cabs. We provide professional drivers and well-maintained vehicles for your convenience and safety."
        },
        {
          "name": "Pan India Cab Service Pune",
          description: "AB Ghule Cabs offers Pan India cab services from Pune. Whether you’re traveling to major cities or remote destinations, we provide reliable, comfortable, and affordable taxi services across India."
        },
        {
          "name": "Pune to Pan India Taxi Service",
          description: "Book a Pan India taxi service with AB Ghule Cabs for reliable travel across the country. We offer affordable, comfortable, and safe taxi services for all your outstation journeys from Pune."
        },
        {
          "name": "Explorer Pan India Cab Service from Pune Contact Number",
          description: "Contact AB Ghule Cabs at +91 8624029699 for prompt and efficient Explorer Pan India cab service from Pune. We ensure a smooth and enjoyable ride for all our customers."
        }
      ],

      tableData : [
        ["- Pune to Ayodhya Cab Service",        "- Pune to taj mahal cabs service"],
        ["- Pune to Kolkata Taxi Fare",          "- Pune to goa taxi fare"],
        ["- Pune to Chennai Cab Service",        "- Pune to Delhi Cab Service"],
        ["- Pune to Mysore Ooty Cab Package",    "- Pune to Kanyakumari Taxi Package"],
        ["- Pune to Kerala Cab Package",         "- Taxi Booking Service in Pune"],
        ["- Pune to Bhopal Cab Service",         "- best travel agents in pimpri chinchwad"],
        ["- Pune to nagpur cab booking",         "- Pune to Patna Cab Service"],
        ["- Pune to Madras Cab Service",         "- Pune to 12 Jyotirlinga Darshan Tour Package"],
        ["- Pune to 5 Jyotirlinga Darshan Cabs", "- Pune to ashtavinayak darshan cab"],
        ["- Pan India Cab Service Pune",         "- Pune to pan india taxi service"]
      ],
      
      whychoose: [
        {
          WhyChooseheading: "Reliable and Professional Service",
          WhyChoosedescription: "AB Ghule Cabs offers reliable and professional pan-India cab services from Pune. Whether you’re heading to a nearby city or exploring a far-off destination, our expert drivers ensure a safe, comfortable, and hassle-free journey, with attention to punctuality and customer satisfaction."
        },
        {
          WhyChooseheading: "24/7 Availability",
          WhyChoosedescription: "No matter when you plan to travel, AB Ghule Cabs is available round-the-clock for your pan-India trips. We are here to serve you any time, day or night, ensuring a seamless travel experience, whether it’s for business, leisure, or special events."
        },
        {
          WhyChooseheading: "Affordable Rates",
          WhyChoosedescription: "Our pan-India taxi services come at competitive rates with no hidden charges. Whether you’re traveling within the state or across the country, we ensure that you get the best value for your money, making us an ideal choice for long-distance travel."
        },
        {
          WhyChooseheading: "Wide Range of Vehicles",
          WhyChoosedescription: "We provide a wide variety of vehicles to choose from, ranging from budget-friendly sedans to spacious SUVs and luxury cars, ensuring you have the perfect ride for your needs, whether you're traveling alone or with a group."
        },
        {
          WhyChooseheading: "Safe and Comfortable Rides",
          WhyChoosedescription: "Your safety is our priority. Our drivers are experienced, background-checked, and trained for long-distance travel. The vehicles are equipped with modern safety features and well-maintained to ensure a smooth and secure ride, no matter the distance."
        },
        {
          WhyChooseheading: "Easy Booking Process",
          WhyChoosedescription: "Booking a pan-India cab with AB Ghule Cabs is straightforward and convenient. You can book your ride through our user-friendly website, mobile app, or by calling our customer service team, and we’ll take care of the rest."
        },
        {
          WhyChooseheading: "Customer Satisfaction",
          WhyChoosedescription: "We have a reputation for excellence in customer service and a long list of satisfied clients. We aim to make your pan-India journey as smooth and enjoyable as possible, providing you with top-notch service and a stress-free travel experience."
        }
      ]
      
  
  

  }

  const faqData = [
    {
      id: 'FAQ1',
      question: 'How can I book an Explorer pan-India cab from Pune?',
      answer: 'You can easily book your pan-India cab through our website, mobile app, or by calling our customer service team. Simply provide your destination and preferred vehicle, and we’ll confirm your booking.',
    },
    {
      id: 'FAQ2',
      question: 'Are the drivers experienced and trustworthy for long-distance travel?',
      answer: 'Yes, all our drivers are highly experienced, professional, and background-checked to ensure you have a safe and pleasant journey across India.',
    },
    {
      id: 'FAQ3',
      question: 'What types of vehicles are available for pan-India travel?',
      answer: 'We offer a wide range of vehicles, including budget sedans, SUVs, and luxury cars, to cater to your specific needs, whether you’re traveling alone, with family, or in a group.',
    },
    {
      id: 'FAQ4',
      question: 'How do I pay for my ride?',
      answer: 'You can pay for your ride using cash, credit/debit cards, or online payment options via our website or mobile app, offering you flexibility and convenience.',
    },
    {
      id: 'FAQ5',
      question: 'Are there any additional charges for long-distance travel?',
      answer: 'Additional charges may apply for long-distance travel, including fuel surcharges, toll fees, and waiting time. However, we ensure full transparency in pricing, and all charges will be communicated to you upfront.',
    },
    {
      id: 'FAQ6',
      question: 'Can I modify or cancel my pan-India cab booking?',
      answer: 'Yes, you can modify or cancel your booking easily through our website or app. Our customer service team is also available to assist with changes or cancellations.',
    },
    {
      id: 'FAQ7',
      question: 'Do you offer both one-way and round-trip services for pan-India travel?',
      answer: 'Yes, we offer both one-way and round-trip services. Whether you’re planning a multi-city tour or a single destination, we provide flexible options to suit your travel plans.',
    },
    {
      id: 'FAQ8',
      question: 'Is AB Ghule Cabs available for group travel across India?',
      answer: 'Yes, we offer spacious vehicles for group travel. Whether it’s a family trip, corporate outing, or group of friends, we can accommodate your entire group comfortably, ensuring everyone enjoys a pleasant journey.',
    },
    {
      id: 'FAQ9',
      question: 'What makes AB Ghule Cabs the best choice for pan-India travel from Pune?',
      answer: 'AB Ghule Cabs is known for its commitment to safety, punctuality, and customer satisfaction. We offer reliable, affordable, and professional services, with a wide selection of vehicles and a team of experienced drivers who ensure your pan-India journey is as comfortable as possible.',
    },
  ];
  
  const testimonials = [
    {
      id: 1,
      name: "Mr. Ankit Joshi",
      feedback: "I used AB Ghule Cabs for a trip from Pune to Goa, and the experience was fantastic! The driver was punctual, the car was well-maintained, and we had a smooth ride the entire way. I will definitely use their services for my future pan-India trips.",
      rating: 5,
    },
    {
      id: 2,
      name: "Mrs. Priya Mehta",
      feedback: "Our family booked a cab from Pune to Delhi for a vacation, and it was one of the best travel experiences we’ve had. The driver was courteous, the vehicle was spacious and comfortable, and the whole process was seamless. Highly recommended!",
      rating: 5,
    },
  ];
  
  






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8624029699",
      

    ],
    email: "booking@abghulecabs.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Mumbai Cab Service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Mumbai to Shirdi Cab",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Mumbai Darshan Cabs",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Mumbai to Vadodara Taxi",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Mumbai to Pune Cab",
    },
    {
      place: "/images/keyword/6.jpg",
      text: " Mumbai to Goa Taxi",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Mumbai Airport Cab",
    },

    {
      place: "/images/keyword/8.jpg",
      text: "Mumbai Surat Cabs",
    },

    {
      place: "/images/keyword/9.jpg",
      text: "Mumbai to Mahabaleshwar Cab",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Mumbai to Konkan Cab",
    },

    {
      place: "/images/keyword/11.jpg",
      text: "Pune Cab Service",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune Taxi Hire",
    },

    {
      place: "/images/keyword/13.jpg",
      text: "Pune Online Cab Booking",
    },

    {
      place: "/images/keyword/14.jpg",
      text: "Best Cab Service in Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Pune to Mumbai Cabs",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Nashik Cabs",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Mahabaleshwar Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Lonavala Cabs",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Shirdi Cab",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Lavasa city cabs",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Bhimashankar Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Indore Cabs",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Konkan Darshan Cabs",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune Outstation Cabs",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Panchgani Cab Fare",
    },
    {
      place: "/images/keyword/26.jpg",
      text: "Pune to Mumbai International Airport Cab",
    },
    {
      place: "/images/keyword/27.jpg",
      text: "Ashtavinayak Darshan Cab",
    },
  ];


  const images = [
    { src: "/images/our-fleet/1.jpg", alt: "Image 1" },
    { src: "/images/our-fleet/2.jpg", alt: "Image 2" },
    { src: "/images/our-fleet/3.jpg", alt: "Image 3" },
    { src: "/images/our-fleet/4.jpg", alt: "Image 4" },
    { src: "/images/our-fleet/5.jpg", alt: "Image 5" },
    { src: "/images/our-fleet/6.jpg", alt: "Image 6" },
    { src: "/images/our-fleet/7.jpg", alt: "Image 7" },
    { src: "/images/our-fleet/8.jpg", alt: "Image 8" },
    { src: "/images/our-fleet/9.jpg", alt: "Image 9" },
  ];





  return (
    <div>
      <Helmet>
  <title>Contact: +91 8624029699 | AB Ghule Cabs | Pan India Cab Service from Pune | Book Cabs for National Destinations</title>
  <meta name="description" content="Explore pan India taxi services from Pune. Offering reliable and affordable cab bookings for Ayodhya, Taj Mahal, Goa, Chennai, Delhi, Ooty, and more. Call +91 8624029699." />
  <meta name="keywords" content="Pune to Ayodhya Cab Service, Pune to Taj Mahal Cabs Service, Pune to Kolkata Taxi Fare, Pune to Goa Taxi Fare, Pune to Chennai Cab Service, Pune to Delhi Cab Service, Pune to Mysore Ooty Cab Package, Pune to Kanyakumari Taxi Package, Pune to Kerala Cab Package, Taxi Booking Service in Pune, Pune to Bhopal Cab Service, Best travel agents in Pimpri Chinchwad, Pune to Nagpur Cab Booking, Pune to Patna Cab Service, Pune to Madras Cab Service, Pune to 12 Jyotirlinga Darshan Tour Package, Pune to 5 Jyotirlinga Darshan Cabs, Pune to Ashtavinayak Darshan Cab, Pan India Cab Service Pune, Pune to Pan India Taxi Service" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8624029699 | AB Ghule Cabs | Pan India Cab Service from Pune | Book Cabs for National Destinations" />
  <meta property="og:description" content="Explore pan India taxi services from Pune. Offering reliable and affordable cab bookings for Ayodhya, Taj Mahal, Goa, Chennai, Delhi, Ooty, and more. Call +91 8624029699." />
  <meta property="og:image" content="https://abghulecabs.com/images/pan-india-cab-service.jpg" />
  <meta property="og:url" content="https://abghulecabs.com/explorer-pan-india-cab-service-pune" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="AB Ghule Cabs" />

  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "TaxiService",
        "name": "AB Ghule Cabs - Pan India Cab Service from Pune",
        description: "Explore pan India taxi services from Pune. Offering reliable and affordable cab bookings for Ayodhya, Taj Mahal, Goa, Chennai, Delhi, Ooty, and more. Call +91 8624029699 for booking.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411057",
          "addressCountry": "IN"
        },
        "telephone": "+91-8624029699",
        "url": "https://abghulecabs.com/explorer-pan-india-cab-service-pune",
        "logo": "https://abghulecabs.com/images/pan-india-cab-service.jpg",
        "image": "https://abghulecabs.com/images/pan-india-cab-service.jpg",
        "priceRange": "₹5000 - ₹15000",
        "offers": {
          "@type": "Offer",
          "url": "https://abghulecabs.com/explorer-pan-india-cab-service-pune",
          "priceCurrency": "INR",
          "price": "5000",
          "priceValidUntil": "2024-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.7",
          "reviewCount": "350"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Anjali K"
            },
            "datePublished": "2024-06-25",
            "reviewBody": "I booked a cab for a trip from Pune to Ayodhya. AB Ghule Cabs provided a comfortable journey with great service. The driver was professional, and the booking process was easy!"
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Rajesh T"
            },
            "datePublished": "2024-09-10",
            "reviewBody": "Booked a cab from Pune to Goa for a family trip. The vehicle was clean, and the driver was friendly. Highly recommend their services for long-distance travel!"
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Pan India",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5195",
            "longitude": "73.8551"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://abghulecabs.com/explorer-pan-india-cab-service-pune"
        },
        "keywords": "Pune to Ayodhya Cab Service, Pune to Taj Mahal Cabs Service, Pune to Kolkata Taxi Fare, Pune to Goa Taxi Fare, Pune to Chennai Cab Service, Pune to Delhi Cab Service, Pune to Mysore Ooty Cab Package, Pune to Kanyakumari Taxi Package, Pune to Kerala Cab Package, Taxi Booking Service in Pune, Pune to Bhopal Cab Service, Best travel agents in Pimpri Chinchwad, Pune to Nagpur Cab Booking, Pune to Patna Cab Service, Pune to Madras Cab Service, Pune to 12 Jyotirlinga Darshan Tour Package, Pune to 5 Jyotirlinga Darshan Cabs, Pune to Ashtavinayak Darshan Cab, Pan India Cab Service Pune, Pune to Pan India Taxi Service"
      }
    `}
  </script>
</Helmet>

      <section id="about" className="jarallax text-light">
        <div className="center-y relative text-center">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <h1 className='text-white'>{cardData.keyword}</h1>
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/67.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#FF4101', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px',
                        transition: 'transform 0.2s'
                      }}

                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ab Ghule Cabs</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        {faqData.map((faq) => (
                          <FAQItem key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <div>

                <div className="contact-box Borderr">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details">
                    <p><strong className='darkcolor'>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}


              <div className="gallery-container">
                <h2 className="gallery-title">Our Fleets</h2>
                <div className="gallery-row d-flex flex-wrap">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
                  {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border "
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #FF4101',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF4101' }}>
                      <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8624029699" className="d-block  text-white">+91 8624029699</a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                        <a href="mailto:booking@abghulecabs.com" className=" text-white d-block">
                          booking@abghulecabs.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                        <p className="whit text-white ">
                          <i> AB Ghule Cabs<br />
                            R -10 Office No -1606,   <br />
                            Life Republic Mulshi, Marunji  <br />
                            Pune, Maharashtra - 411057.

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Explorepanindia;